import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eDotThiActionIds, IDotThiActionTypes } from "../../action-types/to-chuc-thi/IDotThiActions";

import { put, takeLatest } from "redux-saga/effects";
import { dotThiApi } from "../../../api/to-chuc-thi/dotThiApi";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.toChucThi.dotThi;

export function* dotThiSaga(): any {
    yield takeLatest(eDotThiActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IDotThiActionTypes): any {
    const res: IBaseResponse = yield dotThiApi.SelectAll();
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải đợt thi"));
    }
}